<ng-progress
  ngProgressHttp
  #progressBar="ngProgressRef"
  direction="ltr+"
  speed="200"
  trickleSpeed="100"
  fadeOutSpeed="50"
  ease="linear"
  spinner
  class="root-progress-bar"
/>
